"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var table_with_bulk_picker_component_1 = require("./table-with-bulk-picker.component");
var table_with_bulk_picker_builder_component_1 = require("./settings/table-with-bulk-picker-builder.component");
var table_with_bulk_picker_settings_component_1 = require("./settings/table-with-bulk-picker-settings.component");
var common_1 = require("@angular/common");
var ejustice_controls_shared_module_1 = require("../../shared/ejustice-controls-shared.module");
var hierarchical_table_component_1 = require("./entity-table/hierarchical-table/hierarchical-table.component");
var ng2_dragula_1 = require("ng2-dragula");
var col_content_pipe_1 = require("./pipes/col-content.pipe");
var table_header_component_1 = require("./entity-table/table-header/table-header.component");
var forms_1 = require("@angular/forms");
var popup_button_config_component_1 = require("./settings/settings-components/popup-button-config/popup-button-config.component");
var bulk_picker_popup_component_1 = require("./dialogs/bulk-picker/bulk-picker-popup.component");
var keyword_filter_component_1 = require("./dialogs/keyword-filter/keyword-filter.component");
var entity_chips_component_1 = require("./dialogs/entity-chips/entity-chips.component");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var entity_image_url_pipe_1 = require("./pipes/entity-image-url.pipe");
var table_buttons_component_1 = require("./entity-table/table-buttons/table-buttons.component");
var table_entity_actions_component_1 = require("./entity-table/table-entity-actions/table-entity-actions.component");
var cell_width_percentage_pipe_1 = require("./pipes/cell-width-percentage.pipe");
var table_button_config_component_1 = require("./settings/settings-components/table-button-config/table-button-config.component");
var hierarchical_table_tree_node_component_1 = require("./entity-table/hierarchical-table/node/hierarchical-table-tree-node.component");
var dialogs_module_1 = require("../../shared/dialogs/dialogs.module");
var simple_table_component_1 = require("./entity-table/simple-table/simple-table.component");
var directives_module_1 = require("../../shared/directives/directives.module");
var ng_var_directive_1 = require("../../shared/directives/ng-var.directive");
require("@synisys/synergy-design-system");
var TableWithBulkPickerModule = /** @class */ (function () {
    function TableWithBulkPickerModule() {
    }
    TableWithBulkPickerModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                ejustice_controls_shared_module_1.EjusticeControlsSharedModule,
                ng2_dragula_1.DragulaModule,
                forms_1.FormsModule,
                idm_dynamic_forms_ui_1.DynamicFormModule,
                dialogs_module_1.DialogsModule,
                directives_module_1.DirectivesModule
            ],
            declarations: [
                table_with_bulk_picker_component_1.TableWithBulkPickerComponent,
                table_with_bulk_picker_builder_component_1.TableWithBulkPickerBuilderComponent,
                table_with_bulk_picker_settings_component_1.TableWithBulkPickerSettingsComponent,
                table_header_component_1.TableHeaderComponent,
                hierarchical_table_component_1.HierarchicalTableComponent,
                simple_table_component_1.SimpleTableComponent,
                popup_button_config_component_1.PopupButtonConfigComponent,
                table_button_config_component_1.TableButtonConfigComponent,
                col_content_pipe_1.GetColContentPipe,
                entity_image_url_pipe_1.GetEntityImageUrlPipe,
                bulk_picker_popup_component_1.BulkPickerPopupComponent,
                keyword_filter_component_1.KeywordFilterComponent,
                entity_chips_component_1.EntityChipsComponent,
                table_buttons_component_1.TableButtonsComponent,
                table_entity_actions_component_1.TableEntityActionsComponent,
                cell_width_percentage_pipe_1.CellWidthPercentagePipe,
                hierarchical_table_tree_node_component_1.HierarchicalTableTreeNodeComponent,
                ng_var_directive_1.VarDirective
            ],
            exports: [
                table_with_bulk_picker_component_1.TableWithBulkPickerComponent,
                table_with_bulk_picker_builder_component_1.TableWithBulkPickerBuilderComponent,
                table_with_bulk_picker_settings_component_1.TableWithBulkPickerSettingsComponent,
            ],
            providers: [],
            entryComponents: [
                bulk_picker_popup_component_1.BulkPickerPopupComponent
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
        })
    ], TableWithBulkPickerModule);
    return TableWithBulkPickerModule;
}());
exports.TableWithBulkPickerModule = TableWithBulkPickerModule;
//# sourceMappingURL=table-with-bulk-picker.module.js.map